import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import Logo from "../../components/Logo";
import { useRhmAuth } from "../RhmAuthContext";
import { Btn, Field, Input } from "../ui";

export default function RhmLogin() {
    const { user, loading, login } = useRhmAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();
    const loc = useLocation();

    if (loading) return <div className="min-h-screen flex items-center justify-center mono text-xs text-zinc-500">…</div>;
    if (user) return <Navigate to={loc.state?.from || "/rhm"} replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        const res = await login(email.trim(), password);
        setBusy(false);
        if (res.ok) nav(loc.state?.from || "/rhm", { replace: true });
        else setError(res.error);
    };

    return (
        <div className="min-h-screen bg-bg0 flex items-center justify-center px-5">
            <form onSubmit={submit} className="w-full max-w-md bg-bg1 border border-white/10 p-8" data-testid="rhm-login-form">
                <div className="flex items-center gap-3 mb-6">
                    <Logo className="h-9 w-auto" alt="RHM" forceVariant="dark" />
                    <div className="w-10 h-10 border border-gold/40 text-gold flex items-center justify-center">
                        <Lock className="w-4 h-4" />
                    </div>
                </div>
                <h1 className="font-display text-3xl tracking-tight">RHM Business Platform</h1>
                <p className="mono text-[10px] tracking-[0.2em] text-zinc-500 mt-2">STAFF SIGN IN</p>

                <div className="mt-7 space-y-4">
                    <Field label="Work email" required>
                        <Input
                            type="email" required value={email} autoComplete="username"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@rehealthme.com" data-testid="rhm-login-email"
                        />
                    </Field>
                    <Field label="Password" required>
                        <Input
                            type="password" required value={password} autoComplete="current-password"
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••" data-testid="rhm-login-password"
                        />
                    </Field>
                </div>

                {error && (
                    <div className="mt-4 border border-red-500/40 bg-red-500/10 text-red-300 text-sm px-3 py-2" data-testid="rhm-login-error">
                        {error}
                    </div>
                )}

                <Btn type="submit" disabled={busy} className="mt-6 w-full !py-3" data-testid="rhm-login-submit">
                    {busy ? "SIGNING IN…" : "SIGN IN"}
                </Btn>
            </form>
        </div>
    );
}
